// extracted by mini-css-extract-plugin
export default {"icon":"CardIcon_icon__6anQO"};